import React from 'react';

import type { IntlShape } from 'react-intl';

import BoxContainer from '@src/components/BoxContainer';
import Title from '@src/components/BoxContainer/components/Title';
import FilterActiveTags from '@src/components/FilterActiveTags/FilterActiveTags';
import FilterContainer from '@src/components/FilterContainer';
import type { FilterContainerActionButton } from '@src/components/FilterContainer/FilterContainer.interfaces';
import type { SetValueProps } from '@src/components/FilterDropDown/FilterDropDown.interfaces';
import IntlMessages from '@src/util/IntlMessages';

interface TasksDashboardHeaderProps {
  serverPdfAction?: FilterContainerActionButton;
  intl: IntlShape;
  isFilterPanelOpen: boolean;
  onToggleFilters: () => void;
  onCustomFilterChange: (props: SetValueProps) => void;
  /** Reloads the summary sections; the action is hidden when omitted. */
  onRefresh?: () => void;
  /** Blocks the refresh while the sections it reloads are still loading. */
  refreshDisabled?: boolean;
}

/** Report title, filter and export actions, and the active filter tags. */
const TasksDashboardHeader: React.FC<TasksDashboardHeaderProps> = ({
  serverPdfAction,
  intl,
  isFilterPanelOpen,
  onToggleFilters,
  onCustomFilterChange,
  onRefresh,
  refreshDisabled = false,
}) => (
  <>
    <BoxContainer fullContent fixed bottomBorder>
      <FilterContainer
        className="dashboard-report-header"
        title={<Title.Header value={<IntlMessages id="dashboards.tasks.title" />} />}
        actionButtons={[
          {
            label: intl.formatMessage({
              id: isFilterPanelOpen ? 'filterDropdown.closeFilters' : 'dashboard.tooltip.filter',
            }),
            iconName: 'filter_alt',
            type: 'secondary',
            action: onToggleFilters,
            className: isFilterPanelOpen ? 'gx-border-primary' : '',
          },
          ...(onRefresh
            ? [
                {
                  label: intl.formatMessage({ id: 'dashboards.tasks.summary.refresh' }),
                  iconName: 'refresh',
                  type: 'secondary' as const,
                  action: onRefresh,
                  disabled: refreshDisabled,
                },
              ]
            : []),
          ...(serverPdfAction ? [serverPdfAction] : []),
        ]}
      />
    </BoxContainer>
    <FilterActiveTags.Container>
      <FilterActiveTags.Bar>
        <FilterActiveTags.ScrollArea>
          <FilterActiveTags
            onAddFilter={onToggleFilters}
            onCustomFilterChange={onCustomFilterChange}
          />
        </FilterActiveTags.ScrollArea>
      </FilterActiveTags.Bar>
    </FilterActiveTags.Container>
  </>
);

export default TasksDashboardHeader;
